export default __webpack_public_path__ + "static/media/covaimail-newsroom.306f1be6.png";